/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Aside_Help_CtaInputs */

const en_contact_aside_help_cta = /** @type {(inputs: Contact_Aside_Help_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the help centre`)
};

const pl_contact_aside_help_cta = /** @type {(inputs: Contact_Aside_Help_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz centrum pomocy`)
};

/**
* | output |
* | --- |
* | "Open the help centre" |
*
* @param {Contact_Aside_Help_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_aside_help_cta = /** @type {((inputs?: Contact_Aside_Help_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Aside_Help_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_aside_help_cta(inputs)
	return en_contact_aside_help_cta(inputs)
});